/**
 * Builds the DOM id for a time-slot row (e.g. `bigCalendar-time-slot-8`). Scoped
 * by the view's test id to stay unique per calendar instance, so multiple
 * calendars on the same page don't collide on the same slot id. Single source of
 * truth for both setting the id on the slot and looking it up with
 * getElementById in `scrollToCalendarStart`.
 */
export function getTimeSlotElementId(testId: string, hour: number): string {
  return `${testId}-time-slot-${hour}`;
}
